import React, { PureComponent } from 'react';

import { AttachFile as AttachFileIcon } from '@mui/icons-material/';

import {
  Button,
  IconButton,
  TextField,
  LinearProgress,
  List,
  ListItem,
  Checkbox,
  ListItemIcon,
} from '@mui/material';

import { DatePicker } from '@mui/x-date-pickers';

import Tile from '../../../../common/components/Tile/Tile';
import './FileTransfer.css';
import BlobFileList from './BlobFileList/BlobFileList.js';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';
import Loading from '../../../../common/components/Loading/Loading';

import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import Constants from '../../../../common/constants/Constants';
import { connect } from 'react-redux';
import { withRouter } from '../../../../common/utils/NavigationWrapper';
import moment from 'moment';

const TransferFromInstrument = (props) => (
  <div>
    {props.singleFileRequestFileList.length === 0 ? null : (
      <Tile
        className="u-mb-full"
        title="Single file request from instrument"
        helpTag="file_transfer-from_instrument"
      >
        <div className="u-mb-full">
          <div>
            {props.singleFileRequestFileList.find((file) => file.Type === 'Checkbox') ? (
              <List>
                {props.singleFileRequestFileList
                  .filter((file) => file.Type === 'Checkbox')
                  .map((file, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <Checkbox
                          checked={file.Selected}
                          onChange={() => props.handleSingleFileSelection(index)}
                          data-qa="qa-single-file-checkbox"
                        />
                      </ListItemIcon>
                      {file.Name}
                    </ListItem>
                  ))}
              </List>
            ) : null}
            {props.singleFileRequestFileList.find((file) => file.Type === 'TextField')
              ? props.singleFileRequestFileList
                  .filter((file) => file.Type === 'TextField')
                  .map((file, index) => (
                    <TextField
                      variant="standard"
                      data-qa="qa-fileinputTransferFromInstrument"
                      label={file.Name}
                      placeholder="Enter the local absolute path of the file"
                      className="u-mb-double"
                      style={{ width: '80%', display: 'inline-block', marginLeft: '1%' }}
                      value={file.FileNames}
                      onChange={(e) => props.handleFilePathValueChange(e.target.value, index)}
                    />
                  ))
              : null}
          </div>
          <Button
            variant="contained"
            data-qa="qa-requestFileButton"
            className="u-ml-double"
            color="primary"
            onClick={props.onClickRequestFile}
          >
            Request file
          </Button>
        </div>
      </Tile>
    )}
    {props.dateRangeFileRequestFileList.length === 0 ? null : (
      <Tile
        className="u-mb-full"
        title="Request files within a date range from instrument"
        helpTag="file_transfer-from_instrument"
      >
        <div>
          <DatePicker
            slotProps={{
              textField: () => ({
                'data-qa': 'qa-date-from',
              }),
              actionBar: {
                // The actions will be the same between desktop and mobile
                actions: ['cancel', 'accept'],
              },
            }}
            className="u-mr-half"
            closeOnSelect={false}
            style={{ width: '35%', display: 'inline-block', marginLeft: '2%' }}
            label="Date from"
            placeholder="Select from date"
            value={props.data.dateFrom}
            onAccept={(date) => {
              props.handleDateChange(date, null);
            }}
            format={'YYYY-MM-DD'}
            maxDate={props.data.dateTo}
          />
          <DatePicker
            slotProps={{
              textField: () => ({
                'data-qa': 'qa-date-to',
              }),
              actionBar: {
                // The actions will be the same between desktop and mobile
                actions: ['cancel', 'accept'],
              },
            }}
            className="u-mr-half"
            closeOnSelect={false}
            style={{ width: '35%', display: 'inline-block', marginLeft: '10%' }}
            label="Date to"
            placeholder="Select to date"
            value={props.data.dateTo}
            onAccept={(date) => props.handleDateChange(null, date)}
            format={'YYYY-MM-DD'}
            maxDate={moment().add(1, 'days')}
            minDate={props.data.dateFrom}
          />
          {props.dateRangeFileRequestFileList.find((file) => file.Type === 'Checkbox') ? (
            <List>
              {props.dateRangeFileRequestFileList
                .filter((file) => file.Type === 'Checkbox')
                .map((file, index) => (
                  <ListItem key={index}>
                    <ListItemIcon>
                      <Checkbox
                        checked={file.Selected}
                        onChange={() => props.handleDateRangeFileSelection(index)}
                        color="primary"
                        data-qa="qa-single-file-checkbox"
                      />
                    </ListItemIcon>
                    {file.DisplayName}
                  </ListItem>
                ))}
            </List>
          ) : null}

          {props.dateRangeFileRequestFileList.find((file) => file.Type === 'TextField')
            ? props.dateRangeFileRequestFileList
                .filter((file) => file.Type === 'TextField')
                .map((file, index) => (
                  <TextField
                    variant="standard"
                    data-qa="qa-dateRangefileinputTransferFromInstrument"
                    label={file.Name}
                    placeholder="Enter a value"
                    className="u-mb-double"
                    style={{ width: '100%', display: 'inline-block', marginLeft: '1%' }}
                    value={file.FileNames}
                    onChange={(e) => props.handleDateRangePathValueChange(e.target.value, index)}
                  />
                ))
            : null}

          <Button
            variant="contained"
            data-qa="qa-requestLogFileButton"
            className="u-ml-double"
            color="primary"
            onClick={props.onClickRequestLogFile}
          >
            Request log file
          </Button>
        </div>
      </Tile>
    )}
  </div>
);

const TransferToInstrument = (props) => (
  <Tile
    className="u-mb-full"
    title="File transfer to instrument"
    helpTag="file_transfer-to_instrument"
  >
    <div className="u-mb-full">
      <TextField
        variant="standard"
        data-qa="qa-fileinputTransferToInstrument"
        label="File path"
        placeholder="Select a file by clicking the attach button."
        style={{ width: '80%' }}
        value={props.data.fileName}
      />

      <input
        accept="image/*"
        data-qa="qa-fileUploadInput"
        id="browseInput"
        type="file"
        ref={(input) => {
          props.data.fileInput = input;
        }}
        style={{ display: 'none' }}
        onChange={props.onClickFileBrowse}
      />
      <label htmlFor="browseInput">
        <IconButton
          variant="raised"
          data-qa="qa-browseFileButton"
          color="primary"
          component="span"
          size="large"
        >
          <AttachFileIcon />
        </IconButton>
      </label>
    </div>
    <div>
      <Button
        variant="contained"
        data-qa="qa-uploadButton"
        color="primary"
        onClick={props.onClickFileUpload}
      >
        Upload
      </Button>
    </div>
    <div className="u-pt-full">
      <LinearProgress
        data-qa="qa-uploadProgressBar"
        variant="determinate"
        value={props.data.uploadCompleted}
      />
    </div>
  </Tile>
);

class FileTransfer extends PureComponent {
  render() {
    return (
      <div>
        <Loading condition={this.props.isFetching}>
          <PermissionsCheck permission={PermissionsEnum.SEND_FILES}>
            <TransferToInstrument {...this.props} />
          </PermissionsCheck>
          <PermissionsCheck permission={PermissionsEnum.RECEIVE_FILES}>
            <TransferFromInstrument {...this.props} />
          </PermissionsCheck>
          <PermissionsCheck
            permission={[PermissionsEnum.SEND_FILES, PermissionsEnum.RECEIVE_FILES]}
            appliedToPage={true}
          >
            <BlobFileList {...this.props} />
          </PermissionsCheck>
        </Loading>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  _showSnackbar: (notifications) => {
    let message = '';
    message += notifications.map((notification) => {
      return JSON.parse(notification).Status;
    });
    return dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: message,
      })
    );
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FileTransfer));
